import { MDSButton } from "@/mds";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";
import { windowModule } from "@/modules/window";

type TProps = {
  openBtnProps: {
    url: string;
    title: string;
  };
};

export const FloatingPreviewActions = ({ openBtnProps }: TProps) => {
  const { url, title } = openBtnProps;

  return (
    <Container>
      <MDSButton
        onPress={() => {
          windowModule.openInNewTab({
            url: new URL(url),
          });
        }}
      >
        <StyledButtonContent>
          <MdsIcon kind={MdsIconKind.ExternalLink} /> {title}
        </StyledButtonContent>
      </MDSButton>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs};
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.lg};
`;

const StyledButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs};
`;
